import axios from '../plugins/axios'

export default {
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',
    }
  },
  methods: {
    delete_token (e) {
      if (this.loading) {
        return
      }

      const formData = new FormData()
      formData.append('action', 'ia_delete_token')

      this.loading = true

      axios.post('', formData)
        .then(response => {
          location.href = response.data.data.redirect
        })
        .catch(error => {
          console.log(error.response)
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/token.js